export default __webpack_public_path__ + "static/media/assembly-placeholder-logo.20ab3e97.svg";